import { define } from './define';

// "For you": the first screen. What waits for this person, what goes out today, what needs a hand, what just happened.
// Terse: nouns and numbers, no greetings or summaries.
export const home = define({
  es: {
    'home.seeAll': 'Ver todas',

    'home.awaiting.approve': 'Esperan tu aprobación',
    'home.awaiting.comment': 'En revisión',
    'home.awaiting.view': 'En revisión',
    'home.awaiting.cta.approve': 'Revisar',
    'home.awaiting.cta.comment': 'Comentar',
    'home.awaiting.cta.view': 'Ver',
    'home.awaiting.version': 'Versión {n}',
    'home.awaiting.resolves': { one: 'Resuelve {n} de {count} comentario', other: 'Resuelve {n} de {count} comentarios' },
    'home.awaiting.resolvesShort': 'Resuelve {n} de {count}',
    'home.awaiting.open': { one: '{count} comentario abierto', other: '{count} comentarios abiertos' },
    'home.awaiting.moreVariants': { one: '{count} variante más', other: '{count} variantes más' },
    'home.awaiting.empty': 'Nada espera tu decisión.',
    'home.awaiting.emptyReview': 'Nada en revisión.',

    'home.today.title': 'Hoy',
    'home.today.calendar': 'Calendario',
    'home.today.auto': 'automática',
    'home.today.manual': 'a mano',
    'home.today.prepare': 'Preparar',
    'home.today.openPost': 'Ver la publicación en {network}',
    'home.today.empty': 'Hoy no sale nada.',

    'home.attention.title': 'Atención',
    'home.attention.empty': 'Nada que atender.',
    'home.attention.newVersion': 'versión nueva por aprobar',
    'home.attention.movedByYou': 'la confirma otra persona',
    'home.attention.disconnected': 'Desconectada',
    'home.attention.webhook': 'Webhook',
    'home.attention.webhookFailing': 'Falla',
    'home.attention.webhookOff': 'Desactivado',
    'home.attention.agentDeclined': 'El agente lo deja para una persona',
    'home.attention.confirmed': 'Fecha confirmada',
    'home.action.review': 'Revisar',
    'home.action.reconnect': 'Reconectar',
    'home.action.webhooks': 'Ver webhooks',

    'home.activity.title': 'Actividad',
    'home.activity.empty': 'Sin actividad todavía.',
    'home.activity.agent': 'El agente',
    'home.activity.comment': '{who} comentó en {piece}',
    'home.activity.version': '{who} subió la v{n} de {piece}',
    'home.activity.resolved': { one: 'Resuelve {count} comentario', other: 'Resuelve {count} comentarios' },
    'home.activity.approved': '{who} aprobó {piece} para {networks}',
    'home.activity.approvedPlain': '{who} aprobó {piece}',
    'home.activity.rejected': '{who} rechazó la v{n} de {piece}',
    'home.activity.changes': '{who} pidió cambios en {piece}',
    'home.activity.published': '{piece} se publicó en {network}',
    'home.activity.publishedBy': '{who} publicó {piece} en {network}',
    'home.activity.handed': '{who} dejó {piece} para una persona',
    'home.activity.page': 'Pág. {n}',
    'home.activity.more': { one: 'Ver {count} más', other: 'Ver {count} más' },

    'home.ago.now': 'ahora',
    'home.ago.min': '{n} min',
    'home.ago.h': '{n} h',
    'home.ago.yesterday': 'ayer',
    'home.ago.d': '{n} d',
  },
  en: {
    'home.seeAll': 'See all',

    'home.awaiting.approve': 'Waiting for your approval',
    'home.awaiting.comment': 'In review',
    'home.awaiting.view': 'In review',
    'home.awaiting.cta.approve': 'Review',
    'home.awaiting.cta.comment': 'Comment',
    'home.awaiting.cta.view': 'View',
    'home.awaiting.version': 'Version {n}',
    'home.awaiting.resolves': { one: 'Resolves {n} of {count} comment', other: 'Resolves {n} of {count} comments' },
    'home.awaiting.resolvesShort': 'Resolves {n} of {count}',
    'home.awaiting.open': { one: '{count} open comment', other: '{count} open comments' },
    'home.awaiting.moreVariants': { one: '{count} more variant', other: '{count} more variants' },
    'home.awaiting.empty': 'Nothing is waiting for your decision.',
    'home.awaiting.emptyReview': 'Nothing in review.',

    'home.today.title': 'Today',
    'home.today.calendar': 'Calendar',
    'home.today.auto': 'automatic',
    'home.today.manual': 'by hand',
    'home.today.prepare': 'Prepare',
    'home.today.openPost': 'See the post on {network}',
    'home.today.empty': 'Nothing goes out today.',

    'home.attention.title': 'Attention',
    'home.attention.empty': 'Nothing to attend to.',
    'home.attention.newVersion': 'new version to approve',
    'home.attention.movedByYou': 'someone else confirms it',
    'home.attention.disconnected': 'Disconnected',
    'home.attention.webhook': 'Webhook',
    'home.attention.webhookFailing': 'Failing',
    'home.attention.webhookOff': 'Switched off',
    'home.attention.agentDeclined': 'The agent left it to a person',
    'home.attention.confirmed': 'Date confirmed',
    'home.action.review': 'Review',
    'home.action.reconnect': 'Reconnect',
    'home.action.webhooks': 'See webhooks',

    'home.activity.title': 'Activity',
    'home.activity.empty': 'No activity yet.',
    'home.activity.agent': 'The agent',
    'home.activity.comment': '{who} commented on {piece}',
    'home.activity.version': '{who} uploaded v{n} of {piece}',
    'home.activity.resolved': { one: 'Resolves {count} comment', other: 'Resolves {count} comments' },
    'home.activity.approved': '{who} approved {piece} for {networks}',
    'home.activity.approvedPlain': '{who} approved {piece}',
    'home.activity.rejected': '{who} rejected v{n} of {piece}',
    'home.activity.changes': '{who} requested changes on {piece}',
    'home.activity.published': '{piece} went out on {network}',
    'home.activity.publishedBy': '{who} published {piece} on {network}',
    'home.activity.handed': '{who} left {piece} to a person',
    'home.activity.page': 'P. {n}',
    'home.activity.more': { one: 'Show {count} more', other: 'Show {count} more' },

    'home.ago.now': 'now',
    'home.ago.min': '{n} min',
    'home.ago.h': '{n} h',
    'home.ago.yesterday': 'yesterday',
    'home.ago.d': '{n} d',
  },
});
